import { Skeleton } from '@stratascratch/ui'
import {
  AlgorithmExecutionResults,
  ExecutionResults as ExecutionResultsType,
  QuestionClass,
  VisualExecutionResults,
} from '@stratascratch/code-editor'
import CodingResults from './CodingResults'
import AlgorithmResults from './AlgorithmResults'
import VisualResults from './VisualResults'

// import './ExecutionResults.css'

interface Props {
  isLoading: boolean
  questionClass: QuestionClass
  results: ExecutionResultsType | null
}

function ExecutionResults({ isLoading, questionClass, results }: Props) {
  if (isLoading)
    return <Skeleton className="h-64" data-testid="loading-skeleton" />

  if (!results) return null

  switch (questionClass) {
    case 'Algorithm Question':
      return (
        <AlgorithmResults
          results={results as unknown as AlgorithmExecutionResults}
        />
      )
    case 'Visual Question':
      return <VisualResults results={results as VisualExecutionResults} />
    case 'Coding Question':
    default:
      // This is here because we have many Code Editors without questionClass set
      // This should stay until the migration is complete.
      return <CodingResults results={results} />
  }
}

export default ExecutionResults
